var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loading-file-bg"}},[_c('div',{staticClass:"loading-logo"},[_c('p',{staticClass:"text-primary font-medium text-center"},[_vm._v(_vm._s(_vm.textLocal)+"...")])]),_c('div',{staticClass:"loading"},[_c('vs-progress',{staticClass:"mt-3",staticStyle:{"z-index":"300001"},attrs:{"indeterminate":"","color":"primary"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }